import Vue from 'vue'
import Router from 'vue-router';
Vue.use(Router)
const router = new Router({
    base: 'share',
    mode: 'hash',
    routes: [
	{
	    path: '/studyOne',
	    name: 'studyOne',
	    component: () =>
	        import('./views/studyOne.vue'),
	    meta: {
	        title: 'studyOne',
	    }
	},
	{
	    path: '/studyTwo',
	    name: 'studyTwo',
	    component: () =>
	        import('./views/studyTwo.vue'),
	    meta: {
	        title: 'studyTwo',
	    }
	},
	{
	    path: '/studyThree',
	    name: 'studyThree',
	    component: () =>
	        import('./views/studyThree.vue'),
	    meta: {
	        title: 'studyThree',
	    }
	},
	{
	    path: '/studyFour',
	    name: 'studyFour',
	    component: () =>
	        import('./views/studyFour.vue'),
	    meta: {
	        title: 'studyFour',
	    }
	},
	{
	    path: '/invite',
	    name: 'invite',
	    component: () =>
	        import('./views/invite.vue'),
	    meta: {
	        title: 'invite',
	    }
	},
	{
	    path: '/badge',
	    name: 'badge',
	    component: () =>
	        import('./views/badge.vue'),
	    meta: {
	        title: 'badge',
	    }
	},
	]
})
export default router